import { loadStripe } from '@stripe/stripe-js';

const FALLBACK_PUBLISHABLE_KEY = 'pk_live_51RzoVVEHfRZCWZFh5T63wwlguqdDqgHP5kSkIMDQHuaXzoVQzxSolxCFPEsvEmrNty0MsZSWOcKFTQlBGpfRbQ1p00sdLB4FSe';

const PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || FALLBACK_PUBLISHABLE_KEY;

// Log Stripe key validation
const keyPrefix = PUBLISHABLE_KEY.substring(0, 7); // 'pk_live' or 'pk_test'
console.log(`[Stripe] Using publishable key: ${keyPrefix}_***`);

if (keyPrefix === 'pk_test' && window.location.hostname !== 'localhost') {
  console.warn('[Stripe] ⚠️ WARNING: Using TEST Stripe key in production');
}

if (!import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY) {
  console.warn('[Stripe] VITE_STRIPE_PUBLISHABLE_KEY ausente no .env - usando fallback key');
}

export const stripePromise = loadStripe(PUBLISHABLE_KEY);
